module.exports = __webpack_public_path__ + "static/media/wmTrial-words-2.8da84f15.mp3";